/**
 * NoDataBadge — dashed placeholder badge shown when score is null.
 * Matches detail-card.jsx NoDataBadge sizing.
 */
import React from 'react';

interface Props {
  mobile?: boolean;
}

export function NoDataBadge({ mobile = false }: Props) {
  const width = mobile ? 'w-11' : 'w-14';
  const height = mobile ? 'h-[30px]' : 'h-10';
  const fontSize = mobile ? 'text-[10px]' : 'text-[11px]';

  return (
    <div
      className={`${width} ${height} bg-surface-sunken border border-dashed border-hairline rounded flex items-center justify-center ${fontSize} font-semibold tracking-wide text-gray-500`}
      aria-label="No data yet"
    >
      —
    </div>
  );
}
